import {
  getEmployeeSignatureStatusLabel,
  getMonthYearLabel,
  getMyPafStatusLabel,
  getOverallScoreLabel,
  getPafNameLabel,
  getSupervisorNameFromRecord,
} from "pages/AppraisalManagment/utils/myPafHelpers";

/**
 * Returns columns for My PAFs list.
 * Plain factory — do not use hooks here (called during parent render).
 */
const MyPafsColumns = ({
  renderRowActions,
  getWorkflowStatusBadge,
  getSignatureStatusBadge,
}) => [
  {
    id: "sr_no",
    header: "SR No.",
    accessor: null,
    cell: (_, __, rowIndex, sequentialRowNumber) =>
      sequentialRowNumber || (rowIndex !== undefined ? rowIndex + 1 : ""),
    sortable: false,
    searchable: false,
  },
  {
    id: "paf_name",
    header: "PAF Name",
    accessor: (row) => getPafNameLabel(row),
    sortable: true,
    searchable: true,
  },
  {
    id: "month_year",
    header: "Month/Year",
    accessor: (row) => getMonthYearLabel(row),
    sortable: true,
    searchable: true,
  },
  {
    id: "supervisor_name",
    header: "Supervisor Name",
    accessor: (row) => getSupervisorNameFromRecord(row),
    sortable: true,
    searchable: true,
  },
  {
    id: "overall_score",
    header: "Overall Score",
    accessor: (row) => getOverallScoreLabel(row),
    sortable: true,
    searchable: true,
  },
  {
    id: "status",
    header: "Status",
    accessor: (row) => getMyPafStatusLabel(row),
    sortable: true,
    searchable: true,
    cell: (_, row) => getWorkflowStatusBadge(row),
  },
  {
    id: "employee_signature_status",
    header: "Employee Signature Status",
    accessor: (row) => getEmployeeSignatureStatusLabel(row),
    sortable: true,
    searchable: true,
    cell: (_, row) => getSignatureStatusBadge(row),
  },
  {
    id: "actions",
    header: "Actions",
    accessor: null,
    cell: (_, row) => renderRowActions(row),
    sortable: false,
    searchable: false,
  },
];

export default MyPafsColumns;
